import { render, staticRenderFns } from "./DetailPage.vue?vue&type=template&id=83320f86&"
import script from "./DetailPage.vue?vue&type=script&lang=ts&"
export * from "./DetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports